import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

gsap.to('.press__bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".press__bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.companies-about .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".companies-about .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.cica-reports .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".cica-reports .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.board .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".board .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.reports--invest .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".reports--invest .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.reports--events .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".reports--events .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.intro-about .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".intro-about .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.subsidiaries .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".subsidiaries .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.vision .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".vision .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.who-we-are .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".who-we-are .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.p-and-b .bg-txt', {
    xPercent: -250,
    ease: "none",
    scrollTrigger: {
        trigger: ".p-and-b .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});

gsap.to('.hero-fifth .bg-txt', {
    xPercent: -50,
    ease: "none",
    scrollTrigger: {
        trigger: ".hero-fifth .bg-txt",
        start: "-10% 90%",
        end: "bottom top",
        scrub: true
    }
});
